import * as yup from "yup";
import axios from "axios";
import { baseURL } from "services/API";

export const PAYOUT_FREQUENCY_OPTIONS = ["MONTHLY", "WEEKLY", "DAILY"];
export const PAY_WEEK_DAY_OPTIONS = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];
export const LANDLORD_PAYMENT_MODE_OPTIONS = ["MOBILE_MONEY", "BANK", "CASH", "OTHER"];
export const DEFAULT_PAY_PERCENTAGE = "4";

export const initialValuesRegister = {
  business_name: "",
  first_name: "",
  last_name: "",
  email: "",
  contact: "",
  payout_frequency: "MONTHLY",
  pay_day: "",
  pay_week_day: "",
  landlord_payment_mode: "MOBILE_MONEY",
  landlord_payment_account: "",
  landlord_mobile_registered_name: "",
  landlord_bank_name: "",
  landlord_bank_account_number: "",
  landlord_bank_account_name: "",
  landlord_bank_branch: "",
  landlord_bank_sort_code: "",
  terms_agreed: false,
  agreement_template_id: "",
};

export const buildRegisterPayload = (values) => {
  const phoneNumber = values.contact;

  const payload = {
    username: phoneNumber,
    first_name: values.first_name,
    last_name: values.last_name,
    email: values.email || "",
    phone_number: phoneNumber,
    business_name: values.business_name,
    payout_frequency: values.payout_frequency,
    pay_day: values.payout_frequency === "MONTHLY" ? values.pay_day : "",
    pay_week_day: values.payout_frequency === "WEEKLY" ? values.pay_week_day : "",
    pay_percentage: DEFAULT_PAY_PERCENTAGE,
    landlord_payment_mode: values.landlord_payment_mode,
    terms_agreed: true,
    agreement_template_id: values.agreement_template_id,
  };

  if (values.landlord_payment_mode === "MOBILE_MONEY") {
    payload.landlord_payment_account = values.landlord_payment_account || phoneNumber;
    payload.landlord_mobile_registered_name = values.landlord_mobile_registered_name;
  }

  if (values.landlord_payment_mode === "BANK") {
    payload.landlord_bank_name = values.landlord_bank_name;
    payload.landlord_bank_account_number = values.landlord_bank_account_number;
    payload.landlord_bank_account_name = values.landlord_bank_account_name;
    payload.landlord_bank_branch = values.landlord_bank_branch;
    if (values.landlord_bank_sort_code) {
      payload.landlord_bank_sort_code = values.landlord_bank_sort_code;
    }
  }

  return payload;
};

export const registerSchema = yup.object().shape({
  business_name: yup.string().required("required"),
  first_name: yup.string().required("required"),
  last_name: yup.string().required("required"),
  email: yup.string().email("invalid email").required("required"),
  contact: yup
    .string()
    .required("required")
    .test(
      "check-contact",
      "Phone number is already registered",
      async (value) => {
        if (!value) return true;
        try {
          const formData = new FormData();
          formData.append("phone_number", value);
          await axios.post(`${baseURL}/accounts/users/details`, formData);
          return false;
        } catch (contactError) {
          return true;
        }
      }
    ),
  payout_frequency: yup
    .string()
    .oneOf(PAYOUT_FREQUENCY_OPTIONS)
    .required("required"),
  pay_day: yup.string().when("payout_frequency", {
    is: "MONTHLY",
    then: (schema) => schema.required("required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  pay_week_day: yup.string().when("payout_frequency", {
    is: "WEEKLY",
    then: (schema) =>
      schema.oneOf(PAY_WEEK_DAY_OPTIONS).required("required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  landlord_payment_mode: yup
    .string()
    .oneOf(LANDLORD_PAYMENT_MODE_OPTIONS)
    .required("required"),
  landlord_payment_account: yup.string().notRequired(),
  landlord_mobile_registered_name: yup.string().when("landlord_payment_mode", {
    is: "MOBILE_MONEY",
    then: (schema) => schema.required("required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  landlord_bank_name: yup.string().when("landlord_payment_mode", {
    is: "BANK",
    then: (schema) => schema.required("required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  landlord_bank_account_number: yup.string().when("landlord_payment_mode", {
    is: "BANK",
    then: (schema) => schema.required("required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  landlord_bank_account_name: yup.string().when("landlord_payment_mode", {
    is: "BANK",
    then: (schema) => schema.required("required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  landlord_bank_branch: yup.string().when("landlord_payment_mode", {
    is: "BANK",
    then: (schema) => schema.required("required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  landlord_bank_sort_code: yup.string().notRequired(),
  agreement_template_id: yup
    .number()
    .typeError("Please preview the business terms before registering")
    .required("Please preview the business terms before registering"),
  terms_agreed: yup
    .boolean()
    .oneOf([true], "You must agree to the Business Terms"),
});
